import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {CommandService} from '@core/services/command.service';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {DialogService} from '@shared/services/dialog-service';
import {take} from 'rxjs/operators';
import {RenameFormItemCommand, UpdateFormItemCommand} from '../../commands/dac6-reporter.command';
import {getQueryResponse} from "@shared/store/selectors/query.selector";
import {QueryProvider} from "@shared/queries/query-provider";
import {CreateChatConversationCommand} from "../../../task-manager/collaboration/store/collaboration.command";
import {ContentScope} from "@shared/commands/command-base";
import {CreateChatConversationAction} from "../../../task-manager/collaboration/store/collaboration.action";
import {ConversationComponentName} from "../../../task-manager/collaboration/store/collaboration.constants";
import {CollaborationState} from "../../../task-manager/collaboration/store/collaboration.reducer";
import {DialogModel} from '@shared/models/dialog.model';
import { AddFormReportCommand } from '../../../data-survey/commands/report.commands';

@Component({
    standalone: false,
    selector: 'particle-dac6-forms-content',
  templateUrl: './dac6-forms-content.component.html',
  styleUrls: ['./dac6-forms-content.component.scss']
})
export class Dac6FormsContentComponent implements OnInit, OnDestroy {
  breadcrumbs: BreadcrumbModel[];
  unsubscribe$ = new Subject<void>();
  invalidateSubject = new InvalidateSubject();
  endpoint = 'Dac6Api';
  sourceType: string;
  constructor( private router: Router,
               protected commandService: CommandService,
               private queryState: Store<IQueryState>,
               private dialogService: DialogService,
               private collaborationStore: Store<CollaborationState>
  ) {
    this.sourceType = 'DAC6-Form-Item';
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'Case',
        title: 'DAC6 & MDR Reporter',
        type: 'Case',
        relativeUrl: 'dac6-reporter/overview'
      },
      <BreadcrumbModel>{
        id: 'forms',
        title: 'Forms',
        type: 'forms',
        relativeUrl: 'dac6-reporter/filing-manager/forms'
      }
    ];
  }

  ngOnInit() {
  }
  onGridCellValueChange(event) {
    console.log(event);
    if (event.fieldDefinition) {
      switch (event.fieldDefinition.key) {
        case 'CaseId':
          this.router.navigateByUrl(`dac6-reporter/overview/case/${event.item.cells['CaseGUID'].value}`);
          return;
        case 'FormTitle':
          this.openForm(event);
          return;
      }
    }
    if (event.action && event.action.id) {
      switch (event.action.id) {
        case 'Open':
          this.openForm(event);
          return;
        case 'Edit':
            this.edit(event);
            return;
        case 'AddReport':
          this.createReport(event.item);
          return;
        case 'Rename':
          this.renameForm(event.item);
          return;
        case 'OpenCaseFolder':
          this.navigateToCaseFolder(event);
          return;
        case 'Start Conversation':
          this.getChatForThisCase(event);
          return;
      }
    }
  }

  getChatForThisCase(event) {
    const sourceInfoDictionary = {
      'sourceInfoDictionary': {
        CaseGuid: event.item.cells['CaseId'].value,
        caseId: event.item.cells['CaseId'].displayText
      }
    };
    const createChatConversationCommand = new CreateChatConversationCommand(
      '[COMPANY_ID]-chat',
      `${event.item.cells['CaseId'].displayText}`,
      true,
      0,
      'DAC6',
      [],
      true,
      event.item.cells['CaseId'].value,
      sourceInfoDictionary
    );
    createChatConversationCommand.scope = ContentScope.Company;
    this.collaborationStore.dispatch(new CreateChatConversationAction(createChatConversationCommand, ConversationComponentName));
  }
  navigateToCaseFolder(event: any) {
    console.log('navigateToCaseFolder', event);
    if (event.action && event.action.tags.length) {
      let relativePath = event.action.tags[0];
      const caseId = event.item.cells['CaseId'].displayText;
      relativePath = relativePath.replace('[CASE_ID]', caseId);
      console.log('rellativePath', relativePath);
      const relativeUrl$ = this.queryState.pipe(select(getQueryResponse, 'UrlByRelativePath'))
        .pipe(take(2));
      relativeUrl$.subscribe(state => {
        console.log('RelativeUrl', state);
        if (state) {
          this.router.navigateByUrl(state);
        }
      });

      QueryProvider.invokeQuery(this.queryState, 'UrlByRelativePath', {'[RELATIVE_PATH]': relativePath});

    }
  }

  private openForm(event) {
    this.router.navigateByUrl(`dac6-reporter/filing-manager/forms/${event.item.cells['FormId'].value}`);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  createForm() {
    this.router.navigateByUrl(`dac6-reporter/filing-manager/forms/create-form-workflow`);
  }
  createReport(item:any) {
      const dialogModel = DialogModel.create('Add Report', 'AddReportComponent',
        {title: '', description: ''}
        );
      this.dialogService.showOkCancelDialog(dialogModel).pipe(take(1)).subscribe(state => {
        if (state.action === 'OK') {
          this.commandService.executeCommand(new AddFormReportCommand(state.data.input.title, state.data.input.description,item.id))
          .pipe(take(1)).subscribe(commandState => {
            this.router.navigateByUrl(`/reports/${commandState.Payload.Id}`);
        });
        }
      });

  }


  renameForm(item: any) {
    let formTitle = item.cells['FormTitle'].value;
    this.dialogService.showTextInputDialog('Form Titlle', formTitle).
      pipe(take(1)).subscribe(state => {
        console.log(state);
        if (formTitle !== state.data.input.text && state.data.input.text.length) {
          formTitle = state.data.input.text;
          console.log('New Title', formTitle);
          const command = new RenameFormItemCommand(item.id, formTitle);
          this.commandService.executeCommand(command).pipe(take(1)).subscribe(commandState => {
            this.invalidateSubject.invalidate();
          });
        }
    });
  }

  private edit(event: any) {
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition)
      .subscribe(( state => {
        console.log('After Edit', state);
        if (state.action === 'OK') {
            const value = event.item.cells[event.fieldDefinition.key].value;
            const command = new UpdateFormItemCommand(event.item.id, event.fieldDefinition.key, value);
            this.commandService.executeCommand(command).pipe().subscribe(( commandState => {
              console.log(commandState);
              this.invalidateSubject.invalidate();
            }));
        }
      }));
  }
}
